import { useAuth0 } from '@auth0/auth0-react';

import { getCustomerUuid, useDecisions, useIsMounted, useLoyaltyContext, useUserSession } from '@libs/common-next';
import { getAccessToken } from '@libs/core';

export function useAccountSessionLoading() {
    const isAuth0Enabled = useDecisions('auth0');
    const { isAuthenticated: isAuth0Authenticated, isLoading: isAuth0SdkLoading } = useAuth0();
    const { isAuthenticated, user, userData } = useUserSession();
    const { isLoyaltyUnavailable, memberPoints } = useLoyaltyContext();
    const { isMounted } = useIsMounted();

    if (!isMounted) {
        return true;
    }

    if (isAuth0Enabled && (isAuth0SdkLoading || (isAuth0Authenticated && !isAuthenticated))) {
        return true;
    }

    if (!isAuth0Enabled && Boolean(getAccessToken()) && !isAuthenticated) {
        return true;
    }

    if (isAuthenticated && !userData?.profile) {
        return true;
    }

    const shouldLoadLoyaltyData = Boolean(isAuthenticated && getCustomerUuid(user));

    if (shouldLoadLoyaltyData && !isLoyaltyUnavailable && !memberPoints) {
        return true;
    }

    return false;
}
